// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation SubscribeWithMethodMutation($input: SubscribeWithMethodInput!) {
    subscribeWithMethod(input: $input) {
      billingDetails {
        id
        status
        planId
        subscriptionId
        productName
        planName
        planDescription
        planInterval
        planCostUSD
        totalSeats
        active
        trialActive
        trialDaysRemaining
        fullName
        cardType
        cardLast4
        cardExpMonth
        cardExpYear
        cardAddressStatus
        cardZipStatus
        cardCVCStatus
        addressLine1
        addressLine2
        city
        state
        zip
        country
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
